/* eslint-disable react/jsx-props-no-spreading */
const TopprLogo = (props) => (
	<svg height={50} viewBox="0 0 90 36" width={130} {...props}>
		<g fill="none" fillRule="evenodd">
			<rect
				fill="none"
				height={35}
				rx={6}
				stroke="none"
				width={89}
				x={0.5}
				y={0.5}
			/>
			<ellipse
				cx={19.499}
				cy={17.545}
				fill="#fff"
				fillRule="nonzero"
				rx={8.594}
				ry={8.636}
			/>
			<path
				d="M38.479 23.956c-1.743 0 0 0 0 0-1.743 0-2.663-.916-2.663-2.648v-4.996h-1.567v-2.21h1.567v-2.628h2.486v2.628h1.92v2.21h-1.92v4.32c0 .617.314 1.075.862 1.075.372 0 .724-.14.861-.3l.529 1.932c-.372.338-1.038.617-2.075.617zm21.62-5.102c0 3.108-1.738 4.903-4.13 4.903-1.1 0-2.104-.464-2.876-1.429v4.748H50.64V14.202h2.452v1.178c.714-.907 1.737-1.41 2.875-1.41 2.393 0 4.13 1.777 4.13 4.884zm-4.862 2.606c1.388 0 2.34-1.14 2.34-2.819 0-1.659-.952-2.798-2.34-2.798-.78 0-1.655.46-2.074 1.1v3.397c.4.62 1.294 1.12 2.074 1.12zm11.45 2.297c-1.101 0 0 0 0 0-1.101 0-2.105-.464-2.877-1.429v4.748h-2.45V14.202h2.45v1.178c.714-.907 1.737-1.41 2.876-1.41 2.393 0 4.13 1.777 4.13 4.884 0 3.108-1.737 4.903-4.13 4.903zm-.732-2.297c1.388 0 2.34-1.14 2.34-2.819 0-1.659-.952-2.798-2.34-2.798-.78 0-1.655.46-2.074 1.1v3.397c.4.62 1.294 1.12 2.074 1.12zm8.056 2.496h-2.564v-9.743h2.564v1.311c.707-.847 1.898-1.553 3.11-1.553v2.501a3.278 3.278 0 00-.707-.06c-.848 0-1.979.484-2.403 1.11zm-29.054 0c-3.138 0 0 0 0 0-3.138 0-5.033-2.304-5.033-5.002s1.895-4.983 5.033-4.983c3.159 0 5.054 2.284 5.054 4.983s-1.895 5.002-5.054 5.002zm0-1.872c1.634 0 2.532-1.3 2.532-2.819 0-1.499-.898-2.798-2.532-2.798-1.613 0-2.512 1.3-2.512 2.798 0 1.52.899 2.819 2.512 2.819z"
				fill="#000"
			/>
			<path
				d="M19.396 8.086a9.79 9.79 0 012.667.188c2.09.449 4.006 1.662 5.33 3.348a9.393 9.393 0 011.81 3.858 9.73 9.73 0 01-.269 4.95c-.61 1.814-1.774 3.444-3.314 4.577-1.308.975-2.872 1.609-4.494 1.776-1.71.188-3.48-.075-5.035-.825a9.362 9.362 0 01-3.525-2.9 9.564 9.564 0 01-1.187-2.13c-.654-1.638-.804-3.462-.5-5.195a9.285 9.285 0 011.674-3.865A9.388 9.388 0 0116.61 8.72a9.174 9.174 0 012.786-.634zm.104 3.349c-1.812 1.827-3.624 3.652-5.435 5.48-.297.287-.3.82-.003 1.108.365.37.73.74 1.098 1.107.289.29.81.284 1.091-.015.753-.761 1.513-1.516 2.26-2.284a.562.562 0 01.01.125v5.82c.001.103-.005.207.015.31.07.348.4.629.755.625.516.002 1.032.001 1.547 0 .316.004.61-.216.723-.509.064-.165.047-.345.05-.518 0-1.952-.004-3.904.002-5.857.727.74 1.46 1.474 2.19 2.212.078.078.156.158.252.214a.752.752 0 00.797-.026c.096-.068.177-.154.26-.238l.834-.84c.092-.094.192-.185.255-.303.155-.296.107-.695-.135-.93-1.805-1.823-3.614-3.643-5.42-5.465-.287-.334-.851-.342-1.146-.016 0 0 .295-.326 0 0z"
				fill="#55bbea"
			/>
		</g>
	</svg>
);

export default TopprLogo;
